import styled from 'styled-components/macro';

export const LinkContainer = styled.a`
  text-decoration: underline;
`;